
import { Calendar, CalendarDays } from "lucide-react";
import { format } from 'date-fns';
import { Input } from '@shadcn/components/ui/input';

const TopBottomHeader = ({ dateRange, onDateRangeChange }) => {
  const handleStartDateChange = (event) => {
    const dateString = event.target.value;
    const date = new Date(dateString);
    const newRange = { ...dateRange, startDate: date };
    onDateRangeChange(newRange);
  };

  const handleEndDateChange = (event) => {
    const dateString = event.target.value;
    const date = new Date(dateString);
    const newRange = { ...dateRange, endDate: date };
    onDateRangeChange(newRange);
  };

  // Convert Date objects to yyyy-mm-dd format for input[type="date"]
  const formatDateForInput = (date) => {
    if (!date) return '';
    return format(date, 'yyyy-MM-dd');
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Top & Bottom Sales</h1>
        <p className="text-gray-600">Analysis of best and worst performing products sales</p>
      </div>
      
      {/* Date Range Picker */}
      <div className="flex flex-col sm:flex-row gap-4 mt-4 md:mt-0">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <div className="relative">
            <Input
              type="date"
              value={formatDateForInput(dateRange.startDate)}
              onChange={handleStartDateChange}
              max={formatDateForInput(dateRange.endDate)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-full"
            />
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
          </div>
        </div>
        
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">End Date</label>
          <div className="relative">
            <Input
              type="date"
              value={formatDateForInput(dateRange.endDate)}
              onChange={handleEndDateChange}
              min={formatDateForInput(dateRange.startDate)}
              max={formatDateForInput(new Date())}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-full"
            />
            <CalendarDays className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBottomHeader; 
